'use strict';

module.exports = require('./hyphenated.cjs.js');
